import { useState, useEffect, type ReactNode } from 'react'

type Props = {
  items: ReactNode[]
  currentIndex: number
  numberOfVisibleItems: number
  currentElemPosition: 'top' | 'bottom'
}

const LINE_HEIGHT_PX = 28

export const AnimatedList = ({ items, currentIndex, numberOfVisibleItems, currentElemPosition }: Props) => {
  const [slideOffset, setSlideOffset] = useState(0)

  useEffect(() => {
    switch (currentElemPosition) {
      case 'top':
        setSlideOffset(currentIndex * -LINE_HEIGHT_PX)
        break
      case 'bottom':
        if (currentIndex < numberOfVisibleItems) {
          setSlideOffset(0)
          return
        }
        setSlideOffset((currentIndex - numberOfVisibleItems) * -LINE_HEIGHT_PX)
        break
    }
  }, [currentIndex])

  return (
    <div className="relative h-32 overflow-hidden" style={{ height: LINE_HEIGHT_PX * numberOfVisibleItems }}>
      {/* Top Blur */}
      <div className="pointer-events-none absolute left-0 right-0 top-0 z-10 h-12 bg-gradient-to-b from-gray-2 to-transparent" />

      <div
        className="overflow-hidden p-2 transition-transform duration-1000 ease-out"
        style={{
          transform: `translateY(${slideOffset}px)`,
        }}
      >
        {items.map((item, i) => {
          return (
            <div key={i} className={`flex h-7 truncate text-sm text-gray-10`}>
              <span>{item}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
